import { Avatar, Table } from "@shared/ui";
import type { ColumnsType } from "antd/es/table";

import { Brands } from "@shared/lib/types";
import styles from "./BrandSelectionTable.module.scss";

interface BrandSelectionTableProps {
  dataSource: Brands[];
  selectedBrand: string;
  onSelectBrand: (name: string) => void;
  isFetching: boolean;
}

export function BrandSelectionTable({
  dataSource,
  selectedBrand,
  onSelectBrand,
  isFetching,
}: BrandSelectionTableProps) {
  const columns: ColumnsType<Brands> = [
    {
      title: "",
      key: "select",
      width: 48,
      align: "center",
      render: (_, record) => (
        <div
          className={`${styles.radioDot} ${
            selectedBrand === record._id ? styles.radioDotSelected : ""
          }`}
        >
          {selectedBrand === record._id && (
            <div className={styles.radioDotInner} />
          )}
        </div>
      ),
    },
    {
      title: "Brand Details",
      key: "details",
      render: (_, record) => (
        <div className={styles.brandCell}>
          <div
            className={`${styles.brandIcon} `}
          >
            <Avatar 
             src={record.logoUrl}
              alt={record.name}
              size={28}
              shape="square"
            />
            </div>
          <div>
            <div
              className={`${styles.brandName} ${
                selectedBrand === record.name ? styles.brandNameSelected : ""
              }`}
            >
              {record.name}
            </div>
            <div className={styles.brandOrg}>{record.companyName}</div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className={styles.tableWrap}>
      <Table<Brands>
        loading={isFetching}
        rowKey="name"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        showHeader
        onRow={(record) => ({
          onClick: () => onSelectBrand(record._id),
          className: `${styles.clickableRow} ${
            selectedBrand === record._id ? styles.rowSelected : ""
          }`,
        })}
        locale={{ emptyText: "No brands found." }}
      />
    </div>
  );
}
